import * as yup from 'yup';
import { VerificaNombreGrupo } from '../utils/utils';
import { DICTONARY } from 'const/Dictonary';

const createNombreGrupoValidator = setValidating => {
  let timeoutId;
  let cache = {
    value: null,
    result: null,
    lastUpdated: 0
  };
  const DEBOUNCE_TIME = 500; // 0.5 segundos de espera
  const CACHE_TIME = DICTONARY.TOAST.DURATION; // 10 segundos de cache

  return async function (value, { parent }) {
    if (!value) return true;
    if (value.trim().length < 3 && value.length === 0) return true;

    const nombreGrupo = value.trim();
    const { nombreModificado, modificadoEmpresas } = parent;

    // si el valor de empresas ha cambiado, no validar
    if (modificadoEmpresas) return true;

    // Si el valor no ha cambiado, no validar
    if (!nombreModificado) return true;

    // Limpiar timeout anterior
    clearTimeout(timeoutId);

    return new Promise(resolve => {
      timeoutId = setTimeout(async () => {
        // Verificar caché después del debounce
        if (
          cache.value === nombreGrupo &&
          Date.now() - cache.lastUpdated < CACHE_TIME
        ) {
          resolve(!cache.result);
          return;
        }

        // Iniciar validación
        setValidating(true);

        try {
          const isValid = await VerificaNombreGrupo(nombreGrupo);

          // Actualizar caché
          cache.value = nombreGrupo;
          cache.result = isValid;
          cache.lastUpdated = Date.now();
          // Invertir resultado para que sea true si es inválido
          resolve(!isValid);
        } catch (error) {
          resolve(true); // En caso de error, permite el campo
        } finally {
          // console.log('value ::>', value);
          setValidating(false);
        }
      }, DEBOUNCE_TIME);
    });
  };
};

const schemaGrupos = setValidating =>
  yup.object().shape({
    nombreGrupo: yup
      .string()
      .min(3, 'El nombre debe tener al menos 3 caracteres')
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .test(
        'validarNombreGrupo',
        'El nombre ingresado está registrado',
        createNombreGrupoValidator(setValidating)
      ),

    empresas: yup
      .array()
      .min(1, 'Debe seleccionar al menos un elemento')
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
  });

export { schemaGrupos };
